import VueRouter from "vue-router";
import {isArray, isEmpty, isEqual, isString} from "lodash";
import SearchParametersAdapter from "@/utils/Services/SearchParameters/SearchParametersAdapter";

export default class UrlParameterService extends SearchParametersAdapter {

    constructor(router = {}, defaultSortBy = {}, defaultFilters = {}) {
        super(defaultSortBy, defaultFilters);

        if (!(router instanceof VueRouter)) {
            throw 'Router is not an instance of VueRouter';
        }

        this.router = router;
        if (!isEmpty(this.router.currentRoute.query)) {
            this.setParametersByUrl();
        }
    }

    setParametersByUrl() {
        let parameters = this.constructor.formatQueryParameters(this.router.currentRoute.query);

        this.setParameters(parameters);
    }

    pushUrl() {
        if (!isEqual(this.constructor.formatQueryParameters(this.router.currentRoute.query), this.getParameters())) {
            this.router.replace({
                query: this.getParameters(),
            });
        }
    }

    static formatQueryParameters(parameters = {}) {
        for (let key in parameters) {
            let value = parameters[key];

            if (value === '') {
                value = null;
            }
            else if (value === 'false') {
                value = false;
            }
            else if (value === 'true') {
                value = true;
            }
            else if (isString(value) && value === '' + parseInt(value)) {
                value = parseInt(value);
            }
            else if (isArray(value)) {
                for (let key2 in value) {
                    if (isString(value[key2]) && value[key2] == parseInt(value[key2])) {
                        value[key2] = parseInt(value[key2]);
                    }
                }
            }

            parameters[key] = value;
        }

        return parameters;
    }
}
